import moment from 'moment'

// 帳號到期前幾天開始提醒（預設一個月）
export const EXPIRY_WARN_DAYS = 30

// 後端以 '0000-00-00' 表示帳號不過期
const NEVER_EXPIRE_DATE = '0000-00-00'

/**
 * 解析後端回傳的到期日
 * @param {String|null} expireDate 到期日字串（YYYY-MM-DD）
 * @returns {Object|null} moment 物件，無到期日或格式無效時回傳 null
 */
export function parseExpireDate(expireDate) {
  if (!expireDate || expireDate === NEVER_EXPIRE_DATE) return null
  const parsed = moment(expireDate)
  return parsed.isValid() ? parsed : null
}

/**
 * 計算帳號到期狀態，以「日」為單位比較，避免不足一天的誤差與負數天數
 * @param {String|null} expireDate 到期日字串（YYYY-MM-DD）
 * @param {Object} [options] warnDays: 提前提醒天數，now: 比較基準時間
 * @returns {Object|null} 未設定到期日或尚未進入提醒範圍時回傳 null，
 *   否則回傳 { status: 'expired'|'expiring', daysLeft, date }
 *   daysLeft >= 0 表示剩餘天數（0 代表今天到期），< 0 表示已過期天數的相反數
 */
export function getExpiryState(expireDate, options) {
  const config = options || {}
  const warnDays = typeof config.warnDays === 'number' ? config.warnDays : EXPIRY_WARN_DAYS
  const now = config.now ? moment(config.now) : moment()

  const expire = parseExpireDate(expireDate)
  if (!expire) return null

  const daysLeft = expire.clone().startOf('day').diff(now.clone().startOf('day'), 'days')

  // 距離到期日還很久，不需要提醒
  if (daysLeft > warnDays) return null

  return {
    status: daysLeft < 0 ? 'expired' : 'expiring',
    daysLeft,
    date: expire.format('YYYY-MM-DD'),
  }
}
